/* eslint-disable import/no-extraneous-dependencies */
import { Fragment } from 'react'
import { Segmented } from 'antd'
import { CardIconTitle } from '../CardIconTitle/CardIconTitle'
import { GenericTable } from '../GenericTable/GenericTable'
import { Loading } from '../Loading/Loading'
import { TrendingUpIcon } from '../../assets/icons/trending-up'
import { colors } from '../../theme'
import { useModulosTenant } from '../../hooks/useModulosTenant'
import {
  ContainerCard,
  Div,
  Wrapper,
} from '../../pages/PredictionDetails/PredictionDetails.style'
import { useMixRecomendacoes } from './useMixRecomendacoes'
import {
  FeedbackBtn,
  ListaProdutos,
  SemDados,
  ToggleWrapper,
} from './MixRecomendacoes.style'

const formatMoeda = (valor: number) =>
  (valor ?? 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  })

// PD-0002 Mix Inteligente (Fase 3a). Bloco "Categorias recomendadas" no detalhe do cliente. So leitura.
export function MixRecomendacoes() {
  // Gate de visibilidade (UI) por tenant: com o Mix desligado, o bloco nao aparece em nenhuma das
  // telas que o renderizam (detalhe do cliente e detalhe da predicao). Nao afeta jobs/background.
  const { moduloMixInteligenteAtivo } = useModulosTenant()
  const {
    estrategia,
    setEstrategia,
    recomendacoes,
    isLoading,
    chaveAberta,
    abrirCategoria,
    produtos,
    isLoadingProdutos,
    enviarFeedback,
  } = useMixRecomendacoes()

  if (!moduloMixInteligenteAtivo) {
    return null
  }

  const porSegmento = estrategia === 'SEGMENTO'
  const headers = porSegmento
    ? ['Categoria', 'Segmento', 'Potencial (por comprador)', 'Feedback', '']
    : ['Categoria', 'Potencial (por comprador)', 'Feedback', '']

  const renderConteudo = () => {
    if (isLoading) {
      return <Loading contrast={false} />
    }
    if (recomendacoes.length === 0) {
      return <SemDados>Sem recomendações para este cliente ainda.</SemDados>
    }
    return (
      <GenericTable font="14px" spacing="20px" headers={headers}>
        {recomendacoes.map(rec => {
          const faixa = `${formatMoeda(rec.potencialMin)} – ${formatMoeda(
            rec.potencialMax
          )}`
          const chave = `${rec.segmento}-${rec.categoria}`
          const aberta = chaveAberta === chave
          return (
            <Fragment key={chave}>
              <tr
                style={{ cursor: 'pointer' }}
                onClick={() => abrirCategoria(chave, rec.categoria)}
              >
                <td className="col2">{rec.categoria}</td>
                {porSegmento && <td className="col3">{rec.segmento}</td>}
                <td className="col3">{faixa}</td>
                <td className="col3">
                  <FeedbackBtn
                    type="button"
                    title="Útil"
                    aria-label="Útil"
                    ativo={rec.util === true}
                    onClick={event => {
                      event.stopPropagation()
                      enviarFeedback(rec.categoria, true)
                    }}
                  >
                    👍
                  </FeedbackBtn>
                  <FeedbackBtn
                    type="button"
                    title="Não útil"
                    aria-label="Não útil"
                    ativo={rec.util === false}
                    onClick={event => {
                      event.stopPropagation()
                      enviarFeedback(rec.categoria, false)
                    }}
                  >
                    👎
                  </FeedbackBtn>
                </td>
                <td className="colVendas6">{aberta ? '−' : '+'}</td>
              </tr>
              {aberta && (
                <tr>
                  <td colSpan={headers.length}>
                    {isLoadingProdutos ? (
                      <Loading contrast={false} />
                    ) : (
                      <ListaProdutos>
                        {produtos.length === 0 ? (
                          <li>Sem produtos cadastrados nesta categoria.</li>
                        ) : (
                          produtos.map(produto => (
                            <li key={produto.id}>
                              {produto.codigoIntegracao} — {produto.nome}
                            </li>
                          ))
                        )}
                      </ListaProdutos>
                    )}
                  </td>
                </tr>
              )}
            </Fragment>
          )
        })}
      </GenericTable>
    )
  }

  return (
    <Div>
      <Wrapper size="100">
        <ContainerCard>
          <CardIconTitle
            icon={<TrendingUpIcon />}
            background={colors.secondary}
            title="Categorias recomendadas"
          />
        </ContainerCard>
        <ToggleWrapper>
          <Segmented
            value={estrategia}
            onChange={valor => setEstrategia(valor as MixEstrategiaType)}
            options={[
              { label: 'Por similaridade', value: 'JACCARD' },
              { label: 'Por segmento', value: 'SEGMENTO' },
            ]}
          />
        </ToggleWrapper>
        {renderConteudo()}
      </Wrapper>
    </Div>
  )
}
